import React from 'react';
import PriceMenuComponent from './PriceMenuComponent';

function RatesPageMainContainer() {
  return (
    <main role='main' className='grid pt-24 pb-24 full_shadow_black_invert'>
      {/* Price menu */}
      <div className='px-6'>
        <PriceMenuComponent />
      </div>
    </main>
  );
}

export default RatesPageMainContainer;
